exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.error[data-v-0c15f46e],\n.loading[data-v-0c15f46e] {\n  display: inline-block;\n}\n.error i[data-v-0c15f46e],\n.loading i[data-v-0c15f46e] {\n  margin-right: 5px;\n}\n.error[data-v-0c15f46e] {\n  font-weight: bold;\n}\n", ""]);

